import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["hamburger", "navResponsiveBg", "navMobileMenu"];

  toggleNavMenu() {
    this.hamburgerTarget.classList.toggle("active");

    const navBg = this.navResponsiveBgTarget;
    const menu = this.navMobileMenuTarget;

    if (navBg.classList.contains("nav__position--open")) {
      menu.classList.remove("is-visible");

      setTimeout(() => {
        navBg.classList.remove("nav__position--open");
        navBg.classList.add("nav__position--close");
      }, 100);
    } else {
      navBg.classList.remove("nav__position--close");
      navBg.classList.add("nav__position--open");

      setTimeout(() => {
        menu.classList.add("is-visible");
      }, 200);
    }
  }
}
